import {
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icons } from '../Icons';
import { TagFilterOption, useTagFilter } from './TagFilterContext';

export function TagColumnHeader() {
  const { t } = useTranslation();
  const { filterOption, setFilterOption } = useTagFilter();

  const getFilterIcon = () => {
    switch (filterOption) {
      case TagFilterOption.MyTags:
        return <Icons.AccountCircle boxSize={4} />;
      case TagFilterOption.All:
      default:
        return <Icons.Tag boxSize={4} />;
    }
  };

  return (
    <Flex alignItems="center" gap={2}>
      <Text>{t('general.tags')}</Text>
      <Menu isLazy={true}>
        <MenuButton
          as={IconButton}
          aria-label={t('tags.filter.filterTags')}
          icon={getFilterIcon()}
          size="sm"
          variant="ghost"
          colorScheme="gray"
        />
        <MenuList>
          <MenuItem
            icon={<Icons.Tag boxSize={4} />}
            onClick={() => setFilterOption(TagFilterOption.All)}
            fontWeight={
              filterOption === TagFilterOption.All ? 'bold' : 'normal'
            }
          >
            <Text>{t('tags.filter.all')}</Text>
          </MenuItem>
          <MenuItem
            icon={<Icons.AccountCircle boxSize={4} />}
            onClick={() => setFilterOption(TagFilterOption.MyTags)}
            fontWeight={
              filterOption === TagFilterOption.MyTags ? 'bold' : 'normal'
            }
          >
            <Text>{t('tags.myTags')}</Text>
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
}
